// extracted by mini-css-extract-plugin
export default {"image":"s3j_bnqeLLdIGELvTdNJ","content":"fstx00TtTXWb_RCUCRZo"};